import styled from '@emotion/styled';
import { FC } from 'react';
import TruncateText from './TruncateText';
import { Avatar } from '@lithos';
import { AvatarProps } from '@lithos/Avatar';

const AvatarAndNameWrapper = styled.div<{ maxWidth?: string }>(({ maxWidth }) => ({
  maxWidth: maxWidth ? maxWidth : '200px',
  display: 'flex',
  alignItems: 'center',
}));

const AvatarAndName: FC<AvatarProps & { maxWidth?: string }> = (props) => {
  return (
    <AvatarAndNameWrapper maxWidth={props.maxWidth}>
      <div>
        <Avatar {...props} />
      </div>
      <TruncateText>{props.name}</TruncateText>
    </AvatarAndNameWrapper>
  );
};

export default AvatarAndName;
